import { createGlobalStyle } from 'styled-components';
//import * as Colors from './alluvium-colors';

export const AlluviumConsumerGlobalOverrides = createGlobalStyle`
`;
